import React from 'react'
import PropTypes from 'prop-types';
import './index.scss'
import quoteImg from '../../assets/image/quote@3x.png'

const QuoteInfo = (props) => {
  const {
    data
  } = props
  return (
    <div className='quoteInfoBox flex'
      data-type='discountQuoteInfo'
    >
      <div className='quoteImgBox'>
        <span className='centerImg'></span>
        <img src={quoteImg} alt="quote img" />
      </div>
      <div className='quoteText'>
        <span>
          {data}
        </span>
      </div>
    </div>
  )
}
QuoteInfo.propTypes = {
  data: PropTypes.string
}
export default QuoteInfo